import { useRef } from "react";

import { Box, Text } from "@mode/components";

const BackgroundShape = () => {
  return (
    <svg width="282" height="201" viewBox="0 0 282 201" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M250.868 7C250.868 3.13401 247.734 0 243.868 0H7C3.13401 0 0 3.13401 0 7V49V53V95V103V148V194C0 197.866 3.134 201 6.99999 201H253.084C256.95 201 260.084 197.866 260.084 194V155C260.084 151.134 263.218 148 267.084 148H274.587C278.453 148 281.587 144.866 281.587 141V103V95V56C281.587 52.134 278.453 49 274.587 49H257.868C254.002 49 250.868 45.866 250.868 42V7Z" fill="#C8F169" />
    </svg>
  )
}

export const MobileTitle = ({ title }) => {
  const textRef = useRef(null);

  return (
    <Box
      as="div"
      css={{
        display: 'block',
        pt: '$xxxs',
        color: '$g5',
        position: 'relative',
        '@md': { display: 'none' },
      }}
    >
      <Box css={{ position: 'absolute', width: '80%', top: '8px', height: '100%', zIndex: '0', 'svg': { width: '100%', height: '100%' } }}>
        <BackgroundShape />
      </Box>
      <Text textStyle="h1" as="h1" css={{ fontSize: '12vw', width: '75%', lineHeight: '$100', position: 'relative', zIndex: '1', padding: '4px 8px' }}><Box as="div" ref={textRef}>{title}</Box></Text>
    </Box>
  )
}